var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cb-block",
      class: {
        active:
          _vm.active ||
          _vm.$_.get(
            _vm.movingMode ? _vm.movingBlock : _vm.copyingBlock,
            "id"
          ) === _vm.block.id,
        "child-move-disabled":
          (_vm.movingMode || _vm.copyingMode) &&
          _vm.isChildBlock(
            _vm.movingMode ? _vm.movingBlock.id : _vm.copyingBlock.id,
            _vm.block.id
          ),
        "moving-mode": _vm.movingMode || _vm.copyingMode,
        "preview-mode": _vm.previewMode,
        "drag-mode": _vm.dragMode,
        "drag-hover": _vm.dragHover,
        "drop-disallowed": _vm.dropWarningVisible,
        "has-child": !!_vm.block.children.length,
        "no-child": !_vm.block.children.length,
        terminated: [
          _vm.AUTOMATION_BLOCK_TYPES.CLOSE_CHAT,
          _vm.AUTOMATION_BLOCK_TYPES.TRANSFER_CHAT,
          _vm.AUTOMATION_BLOCK_TYPES.TRANSFER_TO_CHATBOT,
          _vm.AUTOMATION_BLOCK_TYPES.AI_ASSISTANT,
        ].includes(_vm.block.type),
      },
      style: Object.assign(
        {},
        {
          top: _vm.metas[_vm.block.id].y + "px",
          left: _vm.metas[_vm.block.id].x + "px",
        },
        _vm.BlockStyles[_vm.block.type]
      ),
      attrs: { "data-type": _vm.block.type },
      on: {
        dragenter: _vm.dragOver,
        dragleave: _vm.dragLeave,
        dragover: _vm.allowDrop,
        drop: _vm.dropBlock,
        mouseenter: _vm.mouseEnter,
        mouseleave: _vm.mouseLeave,
      },
    },
    [
      _c(
        "div",
        {
          class: { "selected-block": _vm.selected },
          staticStyle: { width: "100%", height: "100%" },
          on: {
            mouseleave: function ($event) {
              _vm.more = false
            },
          },
        },
        [
          !_vm.isAIBlock()
            ? _c("div", { staticClass: "name" }, [
                !_vm.editName
                  ? _c("span", { staticClass: "-editable-block-tittle" }, [
                      _vm._v(_vm._s(_vm.block.name)),
                    ])
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.name,
                          expression: "name",
                        },
                      ],
                      attrs: { id: "name_input-" + _vm.block.id, type: "text" },
                      domProps: { value: _vm.name },
                      on: {
                        blur: function ($event) {
                          _vm.editName = false
                        },
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          _vm.editName = false
                        },
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.name = $event.target.value
                        },
                      },
                    }),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.previewMode &&
          !_vm.editName &&
          !_vm.movingMode &&
          !_vm.copyingMode &&
          !_vm.isAIBlock()
            ? _c(
                "a-dropdown-button",
                {
                  staticClass: "block-menu",
                  attrs: { trigger: ["click"], placement: "topRight" },
                  on: {
                    click: function ($event) {
                      _vm.editName = true
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("chatbotv2.editName")) +
                      "\n            "
                  ),
                  _c(
                    "a-menu",
                    {
                      attrs: { slot: "overlay", placement: "topRight" },
                      on: { click: _vm.$_.noop },
                      slot: "overlay",
                    },
                    [
                      _c(
                        "a-menu-item",
                        {
                          key: "collapse",
                          attrs: { disabled: !_vm.block.children.length },
                          on: { click: _vm.collapse },
                        },
                        [
                          _c("a-icon", {
                            staticStyle: { "font-size": "15px" },
                            attrs: { type: "shrink" },
                          }),
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.collapsed
                                  ? _vm.$t("chatbotv2.expand")
                                  : _vm.$t("chatbotv2.collapse")
                              ) +
                              "\n                "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        {
                          key: "collapseAll",
                          attrs: { disabled: !_vm.block.children.length },
                          on: { click: _vm.collapseAll },
                        },
                        [
                          _c("a-icon", {
                            staticStyle: { "font-size": "15px" },
                            attrs: { type: "shrink" },
                          }),
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.collapsedAll
                                  ? _vm.$t("chatbotv2.expandAll")
                                  : _vm.$t("chatbotv2.collapseAll")
                              ) +
                              "\n                "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("a-menu-divider"),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        {
                          key: "editBlock",
                          attrs: {
                            disabled: [
                              "START_POINT",
                              "DEFAULT_FALLBACK",
                              "FLOW",
                              "SUCCESS",
                              "FAILURE",
                            ].includes(_vm.block.type),
                          },
                          on: {
                            click: function (e) {
                              return _vm.$emit("focusBlock", e, _vm.block)
                            },
                          },
                        },
                        [
                          _c("a-icon", {
                            staticStyle: { "font-size": "15px" },
                            attrs: { type: "edit" },
                          }),
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("chatbotv2.editBlock")) +
                              "\n                "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isShowingMoveBlock()
                        ? _c(
                            "a-menu-item",
                            {
                              key: "moveBlock",
                              on: {
                                click: function ($event) {
                                  return _vm.changeMoveMode(_vm.block)
                                },
                              },
                            },
                            [
                              _c("a-icon", {
                                staticStyle: { "font-size": "15px" },
                                attrs: { type: "drag" },
                              }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("chatbotv2.moveBlock")) +
                                  "\n                "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowingCopyBlock()
                        ? _c(
                            "a-menu-item",
                            {
                              key: "copyBlock",
                              on: {
                                click: function ($event) {
                                  return _vm.changeCopyMode(_vm.block)
                                },
                              },
                            },
                            [
                              _c("a-icon", {
                                staticStyle: { "font-size": "15px" },
                                attrs: { type: "copy" },
                              }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("chatbotv2.copyBlock")) +
                                  "\n                "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("a-menu-divider"),
                      _vm._v(" "),
                      _vm.isShowingDeleteSingleBlock()
                        ? _c(
                            "a-menu-item",
                            {
                              key: "deleteSingleBlock",
                              on: {
                                click: function ($event) {
                                  return _vm.showDeleteConfirmation("single")
                                },
                              },
                            },
                            [
                              _c("a-icon", {
                                staticClass: "text-danger",
                                staticStyle: { "font-size": "15px" },
                                attrs: { type: "delete" },
                              }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t("chatbotv2.deleteSingleBlock")
                                  ) +
                                  "\n                "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowingDeleteBlockWithChildren()
                        ? _c(
                            "a-menu-item",
                            {
                              key: "deleteWithChildren",
                              on: {
                                click: function ($event) {
                                  return _vm.showDeleteConfirmation("multi")
                                },
                              },
                            },
                            [
                              _c("a-icon", {
                                staticClass: "text-danger",
                                staticStyle: { "font-size": "15px" },
                                attrs: { type: "delete" },
                              }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t("chatbotv2.deleteWithChildren")
                                  ) +
                                  "\n                "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("a-menu-divider"),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        {
                          key: "startTestFromHere",
                          on: {
                            click: function ($event) {
                              return _vm.startTestFromHere(_vm.block)
                            },
                          },
                        },
                        [
                          _c("a-icon", {
                            staticStyle: { "font-size": "15px" },
                            attrs: { type: "play-circle" },
                          }),
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("chatbotv2.startTestFromHere")) +
                              "\n                "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("a-menu-divider"),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        {
                          key: "copyBlockId",
                          on: {
                            click: function ($event) {
                              return _vm.copyBlockId(_vm.block)
                            },
                          },
                        },
                        [
                          _c("a-icon", {
                            staticStyle: { "font-size": "15px" },
                            attrs: { type: "copy" },
                          }),
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("chatbotv2.copyBlockId")) +
                              "\n                "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          (_vm.collapsed && _vm.block.type !== "FLOW") ||
          _vm.dragMode ||
          _vm.movingMode ||
          _vm.copyingMode ||
          _vm.needShowAddContextMenu()
            ? _c(
                "div",
                {
                  staticClass: "addContext",
                  class: {
                    "d-block": _vm.collapsed,
                    dragMode: _vm.dragMode,
                    movingMode:
                      (_vm.movingMode || _vm.copyingMode) &&
                      !(
                        _vm.block.children.length > 0 ||
                        (!_vm.metas[_vm.block.id].isRoot &&
                          _vm.block.type === "FLOW") ||
                        _vm.isChildBlock(
                          _vm.movingMode
                            ? _vm.movingBlock.id
                            : _vm.copyingBlock.id,
                          _vm.block.id
                        ) ||
                        [
                          _vm.AUTOMATION_BLOCK_TYPES.TRANSFER_CHAT,
                          _vm.AUTOMATION_BLOCK_TYPES.TRANSFER_TO_CHATBOT,
                        ].includes(_vm.block.type)
                      ),
                  },
                  on: {
                    click: function (e) {
                      return _vm.movingMode || _vm.copyingMode
                        ? _vm.movingMode
                          ? _vm.moveBlock(_vm.block.id)
                          : _vm.copyBlock(_vm.block.id)
                        : _vm.collapsed
                        ? _vm.collapse()
                        : _vm.$emit("openContextMenu", {
                            e: e,
                            block: _vm.block,
                          })
                    },
                  },
                },
                [
                  _c("md-icon", [
                    _vm._v(_vm._s(_vm.collapsed ? "expand" : "add")),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.testState.position === _vm.block.id && _vm.testState.active
            ? _c("div", { staticClass: "pulseBlock" }, [
                _c("div"),
                _vm._v(" "),
                _c("div"),
                _vm._v(" "),
                _c("div"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "block-content",
              on: {
                click: function (e) {
                  return (
                    !_vm.isAIBlock() && _vm.$emit("focusBlock", e, _vm.block)
                  )
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center align-content-center justify-content-start block-icon",
                },
                [
                  _c("BlockIconPreview", {
                    attrs: { "block-type": _vm.block.type },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "blockTypeText" }, [
                    _vm._v(
                      _vm._s(_vm.$t("automation.blocks." + _vm.block.type))
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.movingMode &&
              _vm.block.children.length > 0 &&
              _vm.block.type !== "FLOW" &&
              !_vm.isChildBlock(_vm.movingBlock.id, _vm.block.id)
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                }",
                        },
                      ],
                      staticClass: "move-warning",
                      attrs: {
                        content:
                          "The  " +
                          _vm.movingBlock.type +
                          " block can't be child of  the " +
                          _vm.block.type +
                          " block ",
                      },
                    },
                    [
                      _c("a-icon", {
                        staticStyle: { color: "#b4c0c7", "font-size": "24px" },
                        attrs: { type: "warning", theme: "filled" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.copyingMode &&
              _vm.block.children.length > 0 &&
              _vm.block.type !== "FLOW" &&
              !_vm.isChildBlock(_vm.copyingBlock.id, _vm.block.id)
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                }",
                        },
                      ],
                      staticClass: "move-warning",
                      attrs: {
                        content:
                          "The  " +
                          _vm.copyingBlock.type +
                          " block can't be child of  the " +
                          _vm.block.type +
                          " block ",
                      },
                    },
                    [
                      _c("a-icon", {
                        staticStyle: { color: "#b4c0c7", "font-size": "24px" },
                        attrs: { type: "warning", theme: "filled" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dropWarningVisible
                ? _c("a-alert", {
                    staticClass: "drop-warning-alert",
                    attrs: {
                      message:
                        "The  " +
                        _vm.draggingType +
                        " block can't be child of  the " +
                        _vm.block.type +
                        " block ",
                      type: "warning",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.dropWarningVisible
                ? _c(
                    "div",
                    { staticClass: "drop-warning" },
                    [
                      _c("a-icon", {
                        staticStyle: { color: "#b4c0c7", "font-size": "24px" },
                        attrs: { type: "warning", theme: "filled" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }